// src/views/adminView/contractsView/detalle/DetalleKpis.jsx
// Fila de KPIs del detalle de empresa. Datos reales del contract + conteo de
// pedidos de los últimos 30 días vía useClientVolume30d (misma fuente y caché
// que las tarjetas del Directorio, así el número coincide entre ambas vistas).
import { useTranslation } from "react-i18next";
import { CalendarClock, MapPin, PackageSearch, Plug } from "lucide-react";
import { Stat } from "../../../../components/ui/Stat";
import { formatDate, formatNumberCL } from "../../../../utils/formatters";
import useClientVolume30d from "../../../../hooks/useClientVolume30d";

const DAY_MS = 24 * 60 * 60 * 1000;

export default function DetalleKpis({ contract }) {
  const { t } = useTranslation();
  const addresses = contract?.companyId?.shippingAddresses?.length ?? 0;
  const integrations = contract?.integrations?.length ?? 0;
  const { loading: volumeLoading, countOf } = useClientVolume30d();
  const orders30d = countOf(contract?.companyId?._id);

  // Vigencia: terminada / por vencer (<=30 días) / vigente / indefinida.
  const endDate = contract?.validityPeriod?.endDate;
  let validity;
  if (endDate) {
    const end = new Date(endDate).getTime();
    const now = Date.now();
    if (end < now) {
      validity = { value: t("Terminada"), tone: "error", hint: formatDate(endDate) };
    } else if (end - now <= 30 * DAY_MS) {
      validity = { value: t("Por vencer"), tone: "warning", hint: formatDate(endDate) };
    } else {
      validity = {
        value: t("Vigente"),
        tone: "success",
        hint: `${t("hasta")} ${formatDate(endDate)}`,
      };
    }
  } else {
    validity = { value: t("Indefinida"), tone: "success", hint: null };
  }

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
      <Stat
        label={t("Pedidos últimos 30 días")}
        value={volumeLoading ? "…" : orders30d === null ? "—" : formatNumberCL(orders30d)}
        icon={<PackageSearch aria-hidden="true" />}
        tone="brand"
        hint={orders30d === null && !volumeLoading ? t("No disponible") : t("creados en el período")}
      />
      <Stat
        label={t("Direcciones de envío")}
        value={formatNumberCL(addresses)}
        icon={<MapPin aria-hidden="true" />}
        tone="brand"
      />
      <Stat
        label={t("Integraciones")}
        value={formatNumberCL(integrations)}
        icon={<Plug aria-hidden="true" />}
        tone="info"
      />
      <Stat
        label={t("Vigencia")}
        value={validity.value}
        icon={<CalendarClock aria-hidden="true" />}
        tone={validity.tone}
        hint={validity.hint}
      />
    </div>
  );
}
